import { capitalizeFirstLetter } from '@autone/utils';

export const getConcatenatedSeasonEvent = (
  season?: string | null,
  event?: string | null,
) => {
  if (!season && !event) return undefined;
  if (season && !event) return capitalizeFirstLetter(season);
  if (!season && event) return capitalizeFirstLetter(event);
  return `${capitalizeFirstLetter(season)} ・ ${capitalizeFirstLetter(event)}`;
};
